import { render, staticRenderFns } from "./FilterTreeGrade.vue?vue&type=template&id=188074c2&scoped=true&"
import script from "./FilterTreeGrade.vue?vue&type=script&lang=js&"
export * from "./FilterTreeGrade.vue?vue&type=script&lang=js&"
import style0 from "./FilterTreeGrade.vue?vue&type=style&index=0&id=188074c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188074c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect})
